import '@babel/polyfill'
import './assets/styles.css'
import Vue from 'vue'
import './plugins/vuetify'
import App from './App.vue'
import router from './router'
import store from './store'
import './registerServiceWorker'
import Vuetify from 'vuetify'
import colors from 'vuetify/es5/util/colors'
import VueApexCharts from 'vue-apexcharts'
import '@fortawesome/fontawesome-free/css/all.css'
import '@mdi/font/css/materialdesignicons.css'
import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/firestore';
import VueCookies from 'vue-cookies'
Vue.config.productionTip = false

Vue.use(VueApexCharts)

Vue.use(VueCookies)

Vue.use(Vuetify, {
  theme: {
    primary: colors.blue,
    secondary: '#b0bec5',
    accent: '#8c9eff',
    error: '#b71c1c'
  }
})

new Vue({
  router,
  store,
  render: (h) => h(App),
  created () {
    firebase.initializeApp({
      apiKey: 'AIzaSyA9KiY5eCYcgjQNVgEDtgyplnhZewPdJds',
      authDomain: 'cellarworx-2-1540052536526.firebaseapp.com',
      databaseURL: 'https://cellarworx-2-1540052536526.firebaseio.com',
      projectId: 'cellarworx-2-1540052536526',
      storageBucket: 'cellarworx-2-1540052536526.appspot.com',
      messagingSenderId: '700079389378'
    })
    const db = firebase.firestore()
    db.settings({timestampsInSnapshots: true})
  }
}).$mount('#app')
